import { Outlet } from 'react-router-dom';

export default function Layout() {
  return (
    <div className="font-sans antialiased">
      <Outlet />
    </div>
  );
}
